import { getCurrentSheetIdSelector, getFSContentSelector } from "@/store/flowsheet/flowsheet.slice"
import { useSelector } from "react-redux"

export const useCurrentSheet = () => {
  const content = useSelector(getFSContentSelector)
  const sheetId = useSelector(getCurrentSheetIdSelector)

  return content.sheets.find(item => item.id === sheetId)!
}